export const defaultPac ={
    Adults:2, Children:0, Infants:0
};

export const DIV_ID = 'sbox';
export const DATES_MOMENT_FORMAT = 'YYYY-MM-DD';
export const DATES_DISPLAY_FORMAT = 'DD.MM.YYYY';

// values are limits of each device
export const screenSize = {
    MOBILE: 530,
    PHABLET: 672,
    TABLET: 940,
    DESKTOP_SM: 1200,
    DESKTOP_MD: 1920,
    DESKTOP_LG: 18200
}



// WEBPACK FOOTER //
// ./src/components/common/constants.js